// 获取单个表情包style
export function generateEmojiStyle(params, index, isEditing = false) {
    const { total, size = 24, url, rowCount } = params;
    const xRatio = (1 / (rowCount - 1)) * 100;
    const yRatio = (1 / (Math.ceil(total / rowCount) - 1)) * 100;
    const positionX = (index % rowCount) * xRatio;
    const positionY = Math.floor(index / rowCount) * yRatio;
    const commonStyle = `
    background-image: url(${url});
    display: inline-block;
    background-position: ${positionX}% ${positionY}%;
    background-size: ${100 * rowCount}%;
  `.replace('\n', '');
    if (isEditing) {
        //编辑状态
        return `${commonStyle}width: 1.1em;height: 1.1em;bottom: 2px;vertical-align: middle;position: relative;`;
    }
    return `${commonStyle}width: ${size}px;height: ${size}px;`;
}
// 获取所有表情的style arrays
export function generateEmojiStyles(params) {
    const { total } = params;
    return new Array(total)
        .fill(undefined)
        .map((_item, index) => generateEmojiStyle(params, index));
}
//# sourceMappingURL=generateEmojiClass.js.map